function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import RcTooltip from 'rc-tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { cn } from "../../../lib/utils";
import styles, { globalCss } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
globalCss();

// 弹出位置
export var SideEnum = /*#__PURE__*/function (SideEnum) {
  SideEnum[SideEnum["top"] = 0] = "top";
  SideEnum[SideEnum["left"] = 1] = "left";
  SideEnum[SideEnum["right"] = 2] = "right";
  SideEnum[SideEnum["bottom"] = 3] = "bottom";
  SideEnum[SideEnum["topLeft"] = 4] = "topLeft";
  SideEnum[SideEnum["topRight"] = 5] = "topRight";
  SideEnum[SideEnum["bottomLeft"] = 6] = "bottomLeft";
  SideEnum[SideEnum["bottomRight"] = 7] = "bottomRight";
  SideEnum[SideEnum["leftTop"] = 8] = "leftTop";
  SideEnum[SideEnum["leftBottom"] = 9] = "leftBottom";
  SideEnum[SideEnum["rightTop"] = 10] = "rightTop";
  SideEnum[SideEnum["rightBottom"] = 11] = "rightBottom";
  return SideEnum;
}({});

// 触发方式

export default function Tooltip(_ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    _ref$popupContainer = _ref.popupContainer,
    popupContainer = _ref$popupContainer === void 0 ? typeof document === 'undefined' ? undefined : document.body : _ref$popupContainer,
    _ref$mouseEnterDelay = _ref.mouseEnterDelay,
    mouseEnterDelay = _ref$mouseEnterDelay === void 0 ? 300 : _ref$mouseEnterDelay,
    _ref$mouseLeaveDelay = _ref.mouseLeaveDelay,
    mouseLeaveDelay = _ref$mouseLeaveDelay === void 0 ? 300 : _ref$mouseLeaveDelay,
    overlayClassName = _ref.overlayClassName,
    overlayStyle = _ref.overlayStyle,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    open = _ref.open,
    zIndex = _ref.zIndex,
    _ref$onOpenChange = _ref.onOpenChange,
    onOpenChange = _ref$onOpenChange === void 0 ? function () {} : _ref$onOpenChange,
    _ref$destroyTooltipOn = _ref.destroyTooltipOnHide,
    destroyTooltipOnHide = _ref$destroyTooltipOn === void 0 ? false : _ref$destroyTooltipOn,
    _ref$hasDashedLine = _ref.hasDashedLine,
    hasDashedLine = _ref$hasDashedLine === void 0 ? false : _ref$hasDashedLine,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? false : _ref$stopPropagation,
    _ref$hideAnimation = _ref.hideAnimation,
    hideAnimation = _ref$hideAnimation === void 0 ? false : _ref$hideAnimation,
    _ref$hideWrapper = _ref.hideWrapper,
    hideWrapper = _ref$hideWrapper === void 0 ? false : _ref$hideWrapper,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow;
  // 子元素ref
  var childRef = useRef(null);
  // 弹出偏移量
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    offsetMap = _useState2[0],
    setOffsetMap = _useState2[1];

  // 获取子元素尺寸,用于计算弹出偏移量
  useEffect(function () {
    var _childRef$current, _childRef$current2;
    // 角标尺寸(半)
    var ARROW_SIZE = 6;
    // 角标相对偏移
    var ARROW_MARGIN = 16;
    var childWidth = ((_childRef$current = childRef.current) === null || _childRef$current === void 0 || (_childRef$current = _childRef$current.getBoundingClientRect()) === null || _childRef$current === void 0 ? void 0 : _childRef$current.width) || 0;
    var childHeight = ((_childRef$current2 = childRef.current) === null || _childRef$current2 === void 0 || (_childRef$current2 = _childRef$current2.getBoundingClientRect()) === null || _childRef$current2 === void 0 ? void 0 : _childRef$current2.height) || 0;
    var offsetX = childWidth / 2 - ARROW_MARGIN - ARROW_SIZE;
    var offsetY = childHeight / 2 - ARROW_MARGIN - ARROW_SIZE;
    var map = {
      topLeft: [offsetX, -4],
      top: [0, -4],
      topRight: [-offsetX, -4],
      bottomLeft: [offsetX, 4],
      bottom: [0, 4],
      bottomRight: [-offsetX, 4],
      leftTop: [-4, offsetY],
      left: [-4, 0],
      leftBottom: [-4, -offsetY],
      rightTop: [4, offsetY],
      right: [4, 0],
      rightBottom: [4, -offsetY]
    };
    setOffsetMap(map);
  }, []);
  var returnOverlayClassName = overlayClassName || '';
  if (hideAnimation) {
    if (returnOverlayClassName) {
      returnOverlayClassName += ' ';
    }
    returnOverlayClassName += 'no-animate';
  }
  if (!showArrow) {
    if (returnOverlayClassName) {
      returnOverlayClassName += ' ';
    }
    returnOverlayClassName += 'no-arrow';
  }
  return /*#__PURE__*/_jsx(RcTooltip, {
    prefixCls: "moly-tooltip",
    trigger: trigger,
    defaultVisible: defaultOpen,
    placement: placement,
    onVisibleChange: function onVisibleChange(open) {
      return onOpenChange(open);
    },
    visible: open,
    overlay: title,
    overlayStyle: overlayStyle,
    overlayClassName: returnOverlayClassName,
    mouseEnterDelay: mouseEnterDelay / 1000.0,
    mouseLeaveDelay: mouseLeaveDelay / 1000.0,
    getTooltipContainer: function getTooltipContainer() {
      return popupContainer;
    },
    destroyTooltipOnHide: destroyTooltipOnHide,
    showArrow: showArrow,
    align: {
      offset: offsetMap[placement]
    },
    zIndex: zIndex,
    children: !hideWrapper ? /*#__PURE__*/_jsx("div", {
      className: cn.apply(void 0, ['inline-block'].concat(_toConsumableArray(hasDashedLine ? [styles.molyTooltipUnderline, 'cursor-pointer'] : []))),
      onClick: function onClick(e) {
        if (stopPropagation) e.stopPropagation();
      },
      ref: childRef,
      children: children
    }) : children
  });
}